/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_ContextInputs */

const en_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Context`)
};

const fr_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexte utilisateur`)
};

const de_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerkontext`)
};

const it_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto utente`)
};

const ru_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контекст пользователя`)
};

const es_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto del usuario`)
};

const zh_cn2_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户上下文`)
};

const ja_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーコンテキスト`)
};

const hi_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता संदर्भ`)
};

const pt_pt2_user_context = /** @type {(inputs: User_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto do usuário`)
};

/**
* | output |
* | --- |
* | "User Context" |
*
* @param {User_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_context = /** @type {((inputs?: User_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_user_context(inputs)
	if (locale === "de") return de_user_context(inputs)
	if (locale === "it") return it_user_context(inputs)
	if (locale === "ru") return ru_user_context(inputs)
	if (locale === "es") return es_user_context(inputs)
	if (locale === "zh-CN") return zh_cn2_user_context(inputs)
	if (locale === "ja") return ja_user_context(inputs)
	if (locale === "hi") return hi_user_context(inputs)
	if (locale === "pt-PT") return pt_pt2_user_context(inputs)
	return en_user_context(inputs)
});